export enum CaseActionType {
  RESOLVE = 'RESOLVE',
  RESTART = 'RESTART',
  ABORT = 'ABORT',
  CONTINUE = 'CONTINUE',
  RSU_WATCHDOG_CONTINUE = 'RSU_WATCHDOG_CONTINUE',
  CHECK_PRECONDITIONS = 'CHECK_PRECONDITIONS',
  INTERRUPTED = 'INTERRUPTED',
}

export enum CaseActionRequiredType {
  CREATION_PRECONDITIONS_UNFULFILLED = 'CREATION_PRECONDITIONS_UNFULFILLED',
  EXECUTION_PRECONDITIONS_UNFULFILLED = 'EXECUTION_PRECONDITIONS_UNFULFILLED',
  COMFY_PAUSED = 'COMFY_PAUSED',
  INVALID = 'INVALID',
  RSU_WATCHDOG_PAUSED = 'RSU_WATCHDOG_PAUSED'
}
